import React, { useState, useContext, useEffect } from "react";
import { ThemeContext } from "../../../context/ThemeContext";
import { useParams } from 'react-router-dom';
import "./PPGridLayout.css"; // Import CSS styles
// import UserAccountGridRight from "./Layout/UserAccountGridRight"
import PPGridCenterLayout from "./Layout/PPGridCenter"
import { MediaDisplayContext } from "../../../context/MediaDisplayModeContext";
import "../Styles/common-styles.css"
import './Styles/pp-common-styles.css'

const PostPage = () => {
  const { theme } = useContext(ThemeContext);
  const { displayMode } = useContext(MediaDisplayContext);
  const { postid } = useParams();

  useEffect(() => {
    import(`../Styles/themes/${theme}/themes.css`).then(() => {
      console.log(`Loaded ${theme} styles for User Account`);
    }).catch(() => {
      console.error(`Theme CSS not found for ${theme}`);
    });
  }, [theme]);

  return (
    <div style={{display: "flex", flexDirection: "column"}}>  
      <div className="lp-middle-container" style={{ marginTop: 50, marginLeft: 100}}>
        <PPGridCenterLayout postid={postid} mediaDisplayMode={displayMode} />
      </div>
      <div style={{justifyItems: "center"}}>
        <p className="cmn-copyright">
          Oowlet - A Hybrid Model Social Network, Copyright © InitiumNet Technology Pvt Ltd.
        </p>
      </div>
  </div>
  );
};

export default PostPage;
